/* eslint-disable eqeqeq */
import React, { useState } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { Buffer } from 'buffer';
// Components
import App from '../../../components/app';
// Modules
// Ressources
import { paths } from '../../paths';

interface CyperProps extends WithTranslation {}

const CyperPage = (props: CyperProps): JSX.Element => {
    const classes = useStyles();
    const { t } = props;

    const [stringToConvert, setString] = useState<string>('');

    const changeString = (event) => {
        setString(event.target.value);
    };

    const crypt_salt = 'c4bbcb1fbec99d65bf59d85c8cb62ee';

    /**
     * Secure Hash Algorithm (SHA1)
     * http://www.webtoolkit.info/
     **/
    function SHA1(msg) {
        function rotate_left(n, s) {
            const t4 = (n << s) | (n >>> (32 - s));
            return t4;
        }
        function lsb_hex(val) {
            let str = '';
            let i;
            let vh;
            let vl;
            for (i = 0; i <= 6; i += 2) {
                vh = (val >>> (i * 4 + 4)) & 0x0f;
                vl = (val >>> (i * 4)) & 0x0f;
                str += vh.toString(16) + vl.toString(16);
            }
            return str;
        }
        function cvt_hex(val) {
            let str = '';
            let i;
            let v;
            for (i = 7; i >= 0; i--) {
                v = (val >>> (i * 4)) & 0x0f;
                str += v.toString(16);
            }
            return str;
        }
        function Utf8Encode(string) {
            string = string.replace(/\r\n/g, '\n');
            let utftext = '';
            for (let n = 0; n < string.length; n++) {
                const c = string.charCodeAt(n);
                if (c < 128) {
                    utftext += String.fromCharCode(c);
                } else if (c > 127 && c < 2048) {
                    utftext += String.fromCharCode((c >> 6) | 192);
                    utftext += String.fromCharCode((c & 63) | 128);
                } else {
                    utftext += String.fromCharCode((c >> 12) | 224);
                    utftext += String.fromCharCode(((c >> 6) & 63) | 128);
                    utftext += String.fromCharCode((c & 63) | 128);
                }
            }
            return utftext;
        }
        let blockstart;
        let i, j;
        const W = new Array(80);
        let H0 = 0x67452301;
        let H1 = 0xefcdab89;
        let H2 = 0x98badcfe;
        let H3 = 0x10325476;
        let H4 = 0xc3d2e1f0;
        let A, B, C, D, E;
        let temp;
        msg = Utf8Encode(msg);
        const msg_len = msg.length;
        const word_array = [];
        for (i = 0; i < msg_len - 3; i += 4) {
            j =
                (msg.charCodeAt(i) << 24) |
                (msg.charCodeAt(i + 1) << 16) |
                (msg.charCodeAt(i + 2) << 8) |
                msg.charCodeAt(i + 3);
            word_array.push(j);
        }
        switch (msg_len % 4) {
            case 0:
                i = 0x080000000;
                break;
            case 1:
                i = (msg.charCodeAt(msg_len - 1) << 24) | 0x0800000;
                break;
            case 2:
                i = (msg.charCodeAt(msg_len - 2) << 24) | (msg.charCodeAt(msg_len - 1) << 16) | 0x08000;
                break;
            case 3:
                i =
                    (msg.charCodeAt(msg_len - 3) << 24) |
                    (msg.charCodeAt(msg_len - 2) << 16) |
                    (msg.charCodeAt(msg_len - 1) << 8) |
                    0x80;
                break;
        }
        word_array.push(i);
        while (word_array.length % 16 != 14) word_array.push(0);
        word_array.push(msg_len >>> 29);
        word_array.push((msg_len << 3) & 0x0ffffffff);
        for (blockstart = 0; blockstart < word_array.length; blockstart += 16) {
            for (i = 0; i < 16; i++) W[i] = word_array[blockstart + i];
            for (i = 16; i <= 79; i++) W[i] = rotate_left(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
            A = H0;
            B = H1;
            C = H2;
            D = H3;
            E = H4;
            for (i = 0; i <= 19; i++) {
                temp = (rotate_left(A, 5) + ((B & C) | (~B & D)) + E + W[i] + 0x5a827999) & 0x0ffffffff;
                E = D;
                D = C;
                C = rotate_left(B, 30);
                B = A;
                A = temp;
            }
            for (i = 20; i <= 39; i++) {
                temp = (rotate_left(A, 5) + (B ^ C ^ D) + E + W[i] + 0x6ed9eba1) & 0x0ffffffff;
                E = D;
                D = C;
                C = rotate_left(B, 30);
                B = A;
                A = temp;
            }
            for (i = 40; i <= 59; i++) {
                temp = (rotate_left(A, 5) + ((B & C) | (B & D) | (C & D)) + E + W[i] + 0x8f1bbcdc) & 0x0ffffffff;
                E = D;
                D = C;
                C = rotate_left(B, 30);
                B = A;
                A = temp;
            }
            for (i = 60; i <= 79; i++) {
                temp = (rotate_left(A, 5) + (B ^ C ^ D) + E + W[i] + 0xca62c1d6) & 0x0ffffffff;
                E = D;
                D = C;
                C = rotate_left(B, 30);
                B = A;
                A = temp;
            }
            H0 = (H0 + A) & 0x0ffffffff;
            H1 = (H1 + B) & 0x0ffffffff;
            H2 = (H2 + C) & 0x0ffffffff;
            H3 = (H3 + D) & 0x0ffffffff;
            H4 = (H4 + E) & 0x0ffffffff;
        }
        const res = cvt_hex(H0) + cvt_hex(H1) + cvt_hex(H2) + cvt_hex(H3) + cvt_hex(H4);

        return res.toLowerCase();
    }

    const getHash = (str: string | number, len: number) => {
        return SHA1(`${str}${crypt_salt}`).substring(0, len);
    };

    function hexToBytes(hex) {
        const bytes = [];
        for (let i = 0; i < hex.length; i += 2) {
            bytes.push(parseInt(hex.substr(i, 2), 16));
        }
        return new Uint8Array(bytes);
    }
    function base64Encode(bytes) {
        let binary = '';
        for (let i = 0; i < bytes.length; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return btoa(binary);
    }

    const encode = (id: string, short: boolean = false) => {
        if (!Number(id) || Number(id) < 1) {
            return null;
        }
        const idNumber: number = Number(id);
        if (idNumber > Math.pow(2, 31)) {
            return null;
        }
        const segment1 = getHash(idNumber, short ? 8 : 16);
        let segment2 = getHash(segment1, 8);
        let dec: number = parseInt(segment2, 16);
        dec = dec > idNumber ? dec - idNumber : dec + idNumber;
        segment2 = dec.toString(16);
        segment2 = segment2.padStart(8, '0');
        const segment3 = getHash(segment1 + segment2, 8);
        const hex = segment1 + segment2 + segment3;
        const bin = hexToBytes(hex);
        let oid = base64Encode(bin);
        oid = oid.replace(/[+\\/=]/g, function (match) {
            return { '+': '$', '/': ':', '=': '' }[match];
        });
        return oid;
    };

    const decode = (oid: string) => {
        let seedLength = 0;
        switch (oid.length) {
            case 16:
                seedLength = 8;
                break;
            case 21:
            case 22:
            case 23:
                seedLength = 16;
                break;
            default:
                return 0;
        }
        if (!/^[A-Z0-9\\:\\$]+$/i.test(oid)) {
            return 0;
        }
        const newoid = oid.replace(/[\\$\\:]/g, function (match) {
            return match === '$' ? '+' : '/';
        });
        const bin = Buffer.from(newoid, 'base64');
        const hex = bin.toString('hex');
        if (!new RegExp(`^[0-9a-f]{${seedLength + 16}}$`).test(hex)) {
            return 0;
        }
        const segment1 = hex.substring(0, seedLength);
        const segment2 = hex.substring(seedLength, seedLength + 8);
        const segment3 = hex.substring(seedLength + 8, seedLength + 16);
        const exp2 = getHash(segment1, 8);
        const exp3 = getHash(segment1 + segment2, 8);
        if (segment3 != exp3) {
            return 0;
        }
        const v1 = parseInt(segment2, 16);
        const v2 = parseInt(exp2, 16);
        const id = Math.abs(v1 - v2);
        return id;
    };

    const cypherDecypher = (): JSX.Element => {
        if (Number(stringToConvert)) {
            return (
                <div>
                    <li>
                        <b>{t('cypher.standart')}</b>
                        <br />
                        <span>{encode(stringToConvert, false)}</span>
                    </li>
                    <br />
                    <li>
                        <b>{t('cypher.kds')}</b>
                        <br />
                        <span>{encode(stringToConvert, true)}</span>
                    </li>
                </div>
            );
        } else {
            const result = decode(stringToConvert);
            // 'smart' deduction about ids with a prefix (b for booking or r for reservation)
            if (!result) {
                const [firstLetter, ...others] = stringToConvert;
                const rest = others.join('');
                let clearId = null;
                switch (firstLetter?.toLowerCase()) {
                    case 'b':
                        clearId = decode(rest);
                        if (clearId) {
                            return (
                                <div>
                                    <b>{t('cypher.booking')}</b> N°
                                    <a href={`${paths.bookings}/${clearId}`}>{clearId}</a>
                                </div>
                            );
                        }
                        break;
                    case 'r':
                        clearId = decode(rest);
                        if (clearId) {
                            return (
                                <div>
                                    <b>{t('cypher.reservation')}</b> N°
                                    <a href={`${paths.reservations}/${clearId}`}>{clearId}</a>
                                </div>
                            );
                        }
                        break;
                }
            }
            return result ? (
                <div>
                    <b>ID</b> <span>{result}</span>
                </div>
            ) : null;
        }
    };

    return (
        <App header={{ title: t('cypher.title') }}>
            <div className={classes.infoBox}>{t('cypher.hint')}</div>
            <br />
            {/* <form> */}
            <label>{t('cypher.label')}</label>: <input name="id" value={stringToConvert} onChange={changeString} />
            {/* <input type="submit" /> */}
            {/* </form> */}
            <br />
            <br />
            <div>{cypherDecypher()}</div>
        </App>
    );
};

const useStyles = makeStyles(() =>
    createStyles({
        infoBox: {
            background: '#fafaf9',
            padding: '0.8em 1em',
            marginBottom: 8,
            border: '1px solid #eed',
        },
    }),
);

const CyperPageWithTranslation = withTranslation(['support'])(CyperPage);
export default CyperPageWithTranslation;
